import { teksKontak } from "../chat/chatState";
// INSTRUKSI 28/10/2026 PR #44 tambahan teks bagian B: pesan galat server di tampilan pembeli dalam bahasa yang profesional, tanpa istilah
// teknis (token, autentikasi, qty, nama variabel) dan tanpa nama vendor sistem (Midtrans). Teks server TIDAK diubah (kontrak API & paritas);
// terjemahan hanya di tampilan, pola sama dengan galatAdmin.js. Pesan yang tidak dikenal tampil apa adanya.
import { formatApiErrorDetail } from "./api";
import { teksAman } from "./galatAman";

const SESI_BERAKHIR = "Sesi Anda telah berakhir. Silakan masuk kembali.";
const TETAP = {
  "Token kedaluwarsa": SESI_BERAKHIR,
  "Token tidak valid": SESI_BERAKHIR,
  "Tipe token tidak valid": SESI_BERAKHIR,
  "Pengguna tidak ditemukan": SESI_BERAKHIR,
  "Tidak terautentikasi": "Silakan masuk untuk melanjutkan.",
  // server/akun.js BELUM_SIAP (503 saat JWT_SECRET kosong): nama variabel tidak tampil ke pembeli (review Codex)
  "Akun belum disiapkan (JWT_SECRET belum diisi). Hubungi admin.": "Layanan akun sedang tidak tersedia. Silakan coba beberapa saat lagi.",
  "qty harus bilangan bulat": "Jumlah tidak sesuai.",
  "Layanan pengiriman tidak tersedia, pilih ulang": "Layanan pengiriman tidak tersedia. Silakan pilih ulang.",
  "Not Found": "Halaman tidak ditemukan.",
  "Pembayaran sebelumnya perlu dicek penjual dulu. Silakan hubungi kami lewat WhatsApp.":
    "Pembayaran sebelumnya sedang kami periksa. Silakan hubungi kami melalui WhatsApp.",
  "Terlalu banyak permintaan harga. Harga lihat di checkout, atau coba lagi nanti.":
    "Terlalu banyak permintaan harga. Harga ditampilkan di checkout, atau coba lagi nanti.",
};
const POLA = [
  [/^Qty tidak valid\. Minimum (.+) pcs dan kelipatan (.+) pcs\.$/, (m) => `Jumlah tidak sesuai. Minimal ${m[1]} pcs, kelipatan ${m[2]} pcs.`],
  [/^Qty (.+) tidak valid$/, (m) => `Jumlah ${m[1]} tidak sesuai.`],
  [/^Produk .+ tidak tersedia lagi$/, () => "Produk sudah tidak tersedia."],
  // 409 pembayaran (transaksi masih berjalan / belum pasti berhenti): order_id & nama vendor tidak tampil ke pembeli
  [/Midtrans/, () => "Pembayaran sedang diproses. Silakan coba beberapa saat lagi."],
];

export const terjemahPembeli = (teks) => teksKontak(terjemah(teksAman(teks)));   // PR chat pembeli: chat aktif → "melalui chat"
function terjemah(teks) {
  if (typeof teks !== "string") return teks;
  if (Object.prototype.hasOwnProperty.call(TETAP, teks)) return TETAP[teks];
  for (const [re, fn] of POLA) { const m = teks.match(re); if (m) return fn(m); }
  // prinsip teks 6: "via/lewat WhatsApp" di kalimat server → "melalui WhatsApp"
  return teks.replace(/\b(?:lewat|via) WhatsApp\b/g, "melalui WhatsApp");
}

// Galat validasi (422, daftar {type, loc, msg, ctx}; server/test/data/validasi-422.json) di formulir pembeli: daftar/masuk, profil & sandi,
// alamat, keranjang, checkout. Label = nama isian di layar; isian lain = "Isian".
const LABEL = {
  email: "Email", password: "Kata sandi", new_password: "Kata sandi baru", current_password: "Kata sandi saat ini",
  confirm_password: "Konfirmasi kata sandi", nama: "Nama", nama_usaha: "Nama usaha", telepon: "Nomor telepon", nama_alamat: "Nama alamat",
  nama_penerima: "Nama penerima", jalan: "Alamat", patokan: "Patokan", kelurahan: "Kelurahan", kecamatan: "Kecamatan", kota: "Kota",
  provinsi: "Provinsi", kode_pos: "Kode pos", alamat: "Alamat", qty_pcs: "Jumlah", produk_id: "Produk", token: "Tautan",
  ka_kecamatan_id: "Wilayah", ka_kelurahan_id: "Wilayah", ka_kota_id: "Wilayah",
};
const DATA_SALAH = "Data yang dikirim tidak sesuai. Silakan muat ulang halaman.";
const kunciDari = (loc) => [...(Array.isArray(loc) ? loc : [])].reverse().find((x) => typeof x === "string" && x !== "body") || "";

function satu(e) {
  if (!e || typeof e !== "object" || typeof e.msg !== "string") return terjemahPembeli(formatApiErrorDetail(e));
  const k = kunciDari(e.loc);
  const label = LABEL[k];
  const ctx = e.ctx || {};
  if (!label) return DATA_SALAH;
  switch (e.type) {
    case "missing": return `${label} wajib diisi.`;
    case "string_too_short": return ctx.min_length === 1 ? `${label} wajib diisi.` : `${label} minimal ${ctx.min_length} karakter.`;
    case "string_too_long": return `${label} maksimal ${ctx.max_length} karakter.`;
    case "value_error": return k === "email" ? "Format email tidak valid." : `${label} tidak valid.`;
    default: return `${label} tidak valid.`;
  }
}

// Pengganti formatApiErrorDetail di semua tampilan pembeli
export function pesanGalatPembeli(detail) {
  if (Array.isArray(detail)) return formatApiErrorDetail([...new Set(detail.map(satu))].join(" "));   // hasil terjemahan ikut disaring (nilai ctx)
  return terjemahPembeli(formatApiErrorDetail(detail));
}

// PR login Google (INSTRUKSI 01/11/2026 A8): kode galat dari server di fragmen /masuk-google#galat=<kode> (server/login-google.js) → kalimat
// pembeli. Kode tidak dikenal = gangguan.
const GALAT_GOOGLE = {
  batal: "Masuk dengan Google dibatalkan.",
  sesi: "Sesi masuk sudah berakhir. Silakan coba lagi.",
  gangguan: "Masuk dengan Google sedang tidak bisa dipakai. Silakan masuk dengan email.",
  terdaftar: "Email ini sudah terdaftar. Masuk dengan kata sandi.",
  bentrok: "Email ini sudah tersambung dengan akun Google lain. Masuk dengan kata sandi.",
  belum_verifikasi: "Email akun Google Anda belum terverifikasi. Silakan daftar dengan email.",
  nonaktif: "Akun dinonaktifkan. Hubungi administrator.",
  batas: "Terlalu banyak percobaan. Coba lagi nanti.",
};
export function pesanGalatGoogle(kode) {
  return Object.prototype.hasOwnProperty.call(GALAT_GOOGLE, kode) ? GALAT_GOOGLE[kode] : GALAT_GOOGLE.gangguan;
}
